import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-film-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">80s电影网</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              高清在线看免费不卡，蓝光画质极速播。涵盖电影、电视剧、动漫、综艺等海量影视资源，每日更新热门影片，畅享流畅观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">影视分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快捷链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
              <Link to="/category/movie" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新电影</Link>
              <Link to="/category/tv" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播剧集</Link>
              <Link to="/category/anime" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">动漫番剧</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">免责声明</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              本站所有视频内容均来自互联网，仅供学习交流使用。如有侵犯您的权益，请及时联系我们处理。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/40 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-400">
            &copy; {new Date().getFullYear()} 80s电影网 - 高清在线看免费不卡 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}